import TextField from '@material-ui/core/TextField';
import React from 'react';

import FieldBase from './Base';

export default class FieldSelect extends FieldBase {
  onChange(event: any) {
    const value = event.target ? event.target.value : event;
    super.onChange(value);
  }

  render() {
    const { value } = this.props;

    return (
      <div ref={this.inputRef}>
        {super.render()}

        <TextField
          {...{
            fullWidth: true,
            margin: 'normal',
            ...this.props,
            value: value === undefined ? '' : value,
            select: true,
            error: !!this.errorMessage,
            helperText: <span>{this.errorMessage}</span>,
            onChange: this.onChange.bind(this),
            onBlur: this.onBlur.bind(this),
            submitted: null,
            FormHelperTextProps: {
              classes: {
                root: 'field-error',
                error: 'error',
                disabled: 'disabled'
              }
            },
            touched: null
          }}
        >
          {this.props.children}
        </TextField>
      </div>
    );
  }
}
